<template>
  <ax-dialog
    ref="dialog"
    title="Share"
    icon="mdi-share-variant-outline"
    size="small"
    @shown="onShow"
    @submitted="onSubmit"
  >
    <template slot="content">
      <v-card-text>
        <v-autocomplete 
          label="Select user(s)"
          v-model="users.selected"
          :items="users.list"
          multiple chips
        />
      </v-card-text>
    </template>
  </ax-dialog>
</template>
<script>
import AxDialog from "@/components/dialog"
import Users from '@/api/users'
import Files from '@/api/files'
import Datasets from '@/api/datasets'
import Predictions from '@/api/predictions'
export default {
  name: "Share",
  props: {
    mode: { type: String, required: true },
    item: { type: Object, required: true }
  },
  components: { AxDialog },
  data() {
    return {
      headers: [
        { text: 'User', value: 'user', width: '99%' },
        { text: 'Permission', value: 'write', align: 'center' },
        { text: 'Allowed', value: 'created_at', align: 'center' },
        { text: 'Delete', value: 'action', align: 'center' },
      ],
      users: {
        selected: [],
        list: []
      },
    }
  },
  computed: {
    icon() {
      if (this.mode == "file") return "mdi-file-document"
      if (this.mode == "dataset") return "mdi-database"
      if (this.mode == "prediction") return "mdi-finance"
      return "mdi-apps"
    },
    valid() {
      return this.users.selected.length == 0
    }
  },
  methods: {
    onShow(shown) {
      if (shown) {
        Users.list().then(response => {
          this.users.list = response.data
                            .filter(u => u.username !== this.user.username)
                            .map(user => { return { text: user.name, value: user.id } })
          this.users.selected = this.item.users
        })
      } else {
        this.users.selected = []
        this.users.list = []
      }
    },
    onSubmit() {
      if (this.mode == "file") {
        this.shareFile()
      } else if (this.mode == "dataset") {
        this.shareDataset()
      } else if (this.mode == "prediction") {
        this.sharePrediction()
      }
    },
    shareFile() {
      Files.patch(this.item.uuid, { users: this.users.selected })
        .then(_ => {
          this.notify('File shared successfully')
          this.refresh()
        })
    },
    shareDataset() {
      Datasets.patch(this.item.uuid, { users: this.users.selected })
        .then(_ => {
          this.notify('Dataset shared successfully')
          this.refresh()
        })
    },
    sharePrediction() {
      Predictions.patch(this.item.uuid, { users: this.users.selected })
        .then(_ => {
          this.notify('Prediction shared successfully')
          this.refresh()
        })
    },
  }
}
</script>